'use client';
import {
  WITHIN_6KM,
  WITHIN_RIYADH,
} from '@/constants/delivery-types.constants';
import useGlobalStore from '@/store/global.store';
import { useTranslations } from 'next-intl';
import { FiMapPin } from 'react-icons/fi';
import { LuPencil } from 'react-icons/lu';
import { CiDeliveryTruck } from 'react-icons/ci';
import useShippingInfoStore from '@/store/shipping-info.store';

const ProductDelivery = () => {
  const shippingAddress = useShippingInfoStore(
    (state) => state.shippingAddress
  );

  const setIsOpenShippingInfoModal = useShippingInfoStore(
    (state) => state.setIsOpenShippingInfoModal
  );
  const deliveryPlaceType = useGlobalStore((state) => state.deliveryPlaceType);
  const t = useTranslations('product');

  return (
    <div className='rounded-lg border border-green-200 bg-green-50 p-3 transition-shadow hover:shadow-md'>
      <div className='mb-1.5 flex items-start gap-2'>
        <FiMapPin size={16} className='mt-1 flex-shrink-0 text-blue-600' />
        <div className='flex-1'>
          <div className='flex items-center justify-between'>
            <div className='text-sm font-medium'>{t('deliver_to')}:</div>
            <button
              onClick={() => setIsOpenShippingInfoModal(true)}
              className='flex items-center text-xs font-medium text-blue-600'
            >
              <LuPencil size={12} className='me-1' />
              {t('Edit')}
            </button>
          </div>
          <div className='line-clamp-1 max-w-10/12 text-xs text-gray-600'>
            {shippingAddress?.street?.[0] || t('empty_address')}
          </div>
        </div>
      </div>

      <div className='mt-1 flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          <CiDeliveryTruck size={16} className='flex-shrink-0 text-green-600' />
          <div>
            <div className='text-sm font-medium'>
              {' '}
              {deliveryPlaceType === WITHIN_6KM
                ? t('Instant Delivery')
                : t('Delivery')}
            </div>
            <div className='text-xs text-blue-500'>
              {' '}
              {deliveryPlaceType === WITHIN_6KM
                ? t('delivery_in', { time: 30 })
                : deliveryPlaceType === WITHIN_RIYADH
                  ? t('tomorrow')
                  : t('from_1_day_to_3_days')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDelivery;
